import React from 'react';
import { StyledIcon, StyledPageNumber, StyledPagination, StyledText, StyledPaginationInfo, StyledPaginationControls, } from './Pagination.styles';
export function Pagination({ currentPage, totalPageCount, totalRowCount, totalRowsOnPage, paginationLimit, nextPage, previousPage, }) {
    const isLastPage = currentPage === totalPageCount - 1;
    const isFirstPage = currentPage === 0;
    const firstRowPosition = currentPage * paginationLimit;
    const handlePreviousPage = () => {
        if (currentPage > 0) {
            previousPage();
        }
    };
    const handleNextPage = () => {
        if (currentPage < totalPageCount - 1) {
            nextPage();
        }
    };
    return (React.createElement(StyledPagination, null,
        React.createElement(StyledPaginationInfo, null,
            "Showing ",
            firstRowPosition + 1,
            " - ",
            firstRowPosition + totalRowsOnPage,
            " of ",
            totalRowCount,
            ' ',
            "entries"),
        React.createElement(StyledPaginationControls, null,
            React.createElement(StyledIcon, { name: "chevron-left", onClick: handlePreviousPage, isDisabled: isFirstPage }),
            React.createElement(StyledText, null,
                "Page",
                ' ',
                React.createElement(StyledPageNumber, null,
                    React.createElement("span", null, currentPage + 1)),
                "of ",
                totalPageCount === 0 || !totalPageCount ? 1 : totalPageCount),
            React.createElement(StyledIcon, { name: "chevron-right", onClick: handleNextPage, isDisabled: isLastPage }))));
}
//# sourceMappingURL=Pagination.js.map